import { render } from "./ChangePassword.vue?vue&type=template&id=1a7eed19&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=1a7eed19&lang=css"
import "./ChangePassword.vue?vue&type=style&index=1&id=1a7eed19&lang=scss"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__